import { render } from "./SelectFile.vue?vue&type=template&id=2fad4995"
import script from "./SelectFile.vue?vue&type=script&lang=js"
export * from "./SelectFile.vue?vue&type=script&lang=js"

import "./SelectFile.vue?vue&type=style&index=0&id=2fad4995&lang=css"
script.render = render

export default script